import { graphqlFetch } from '@pylot-data/graphqlFetch'
import {
    salesUnitsConfigQuery,
    SalesUnitsConfigOutput
} from '@pylot-data/api/operations/graphql/salesUnitsConfigQuery'

export type SalesUnitsConfig = {
    label: string
    threshold: number
}

let salesUnitsConfigPromise: Promise<SalesUnitsConfig | null> | null = null

const normalizeSalesUnitsConfig = (
    response?: SalesUnitsConfigOutput | null
): SalesUnitsConfig | null => {
    const salesUnits = response?.config?.base?.sales_units
    const threshold = salesUnits?.last_units
    const label = salesUnits?.label_text?.trim() ?? ''

    if (
        !salesUnits?.enable_sales_units ||
        !label ||
        typeof threshold !== 'number' ||
        threshold <= 0
    ) {
        return null
    }

    return { label, threshold }
}

export const getSalesUnitsConfig =
    async (): Promise<SalesUnitsConfig | null> => {
        if (!salesUnitsConfigPromise) {
            salesUnitsConfigPromise = graphqlFetch<
                Record<string, never>,
                SalesUnitsConfigOutput
            >({
                query: salesUnitsConfigQuery
            })
                .then(({ data }) => normalizeSalesUnitsConfig(data))
                .catch(() => null)
        }

        return salesUnitsConfigPromise
    }
